// ----------------------------------------------------------------------------
// Template: Blog
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'sections/header/header';
import 'snippets/pagination/pagination';
import 'sections/page-header/page-header';
import 'sections/blog-posts/blog-posts';
import 'sections/footer/footer';

// Styles
import './_blog.scss';

document.querySelector('.blog__tag--current')?.scrollIntoView({behavior: 'smooth', block: 'center', inline: 'center'});
